export default [
  {
    path: "/project/:proj_id",
    component: () => import("@/layouts/ProjectLayout.vue"),
    meta: {
      authRequired: true,
    },
    children: [
      {
        path: "field/info/:type",
        name: "field-info-type",
        meta: {
          activeCode: "field-info",
        },
        component: () => import("@/views/_BS/FieldInfo.vue"),
      },

      // ==========
      {
        path: "company/info",
        name: "company-info",
        meta: {
          activeCode: "company-info",
        },
        component: () => import("@/views/_BS/CompanyInfo.vue"),
      },
    ],
  },
];
